module.exports = __webpack_public_path__ + "media/images/logos/favicon-47ae2f1caf986330457b481710bca329.png";